module.exports = __webpack_public_path__ + "static/img/nav4.57729ba5.png";